module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-04.1238073d.png";